import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DemoModeBannerComponent } from './features/demo/demo-mode-banner.component';
import { ServiceNoticeBannerComponent } from './shared/service-notice-banner.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { HttpClientModule } from '@angular/common/http';

import { AngularFireModule } from '@angular/fire/compat';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { environment } from 'src/environments/environment';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';

import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {MatCard, MatCardModule} from '@angular/material/card';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule} from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatStepperModule} from '@angular/material/stepper';
import { FormBuilder, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule} from '@angular/material/table';
import {  MatPaginatorModule } from '@angular/material/paginator';
import {MatIconModule} from '@angular/material/icon';
import { CommonModule, DatePipe } from '@angular/common';

import {MatDialogModule} from '@angular/material/dialog';
import {MatSnackBarModule} from '@angular/material/snack-bar';

import { MatExpansionModule } from '@angular/material/expansion';
import {MatTabsModule} from '@angular/material/tabs';

import {MatMenuModule} from '@angular/material/menu';

import { TimestampToDatePipe } from './timestamp-to-date.pipe';
import {MatRadioModule} from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';


import { LocationStrategy } from '@angular/common';
import { PublicMarketingLocationStrategy } from './core/public-marketing-location.strategy';
import { RouterModule } from '@angular/router';

import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { AngularFireFunctionsModule } from '@angular/fire/compat/functions';

import { MatSortModule } from '@angular/material/sort';
import { MatChipsModule } from '@angular/material/chips';
import { AuthTokenInterceptor } from './core/token.interceptor';
import { REGION } from '@angular/fire/compat/functions';
import { LoginComponent } from './authetification/login/login.component';
import { AccountDialogComponent } from './COMPONENT/account-dialog/account-dialog.component';
import { CountDownComponent } from './COMPONENT/count-down/count-down.component';
import { provideFirebaseApp } from '@angular/fire/app';
import { provideAuth } from '@angular/fire/auth';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { OverviewComponent } from './modules/pages/overview/overview.component';
import { DashboardComponent } from './modules/pages/dashboard/dashboard.component';
import { CaseListComponent } from './modules/pages/case-list/case-list.component';
import { PrecautionComponent } from './modules/pages/precaution/precaution.component';
import { StaffComponent } from './modules/pages/staff/staff.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';


@NgModule({
  declarations: [
    AppComponent,
    TimestampToDatePipe,
    LoginComponent,
    AccountDialogComponent,
    CountDownComponent,
    OverviewComponent,
    DashboardComponent,
    CaseListComponent,
    PrecautionComponent,
    StaffComponent,
  ],
  imports: [
    DemoModeBannerComponent,
    ServiceNoticeBannerComponent,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AngularFireModule.initializeApp(environment.firebase),
    provideFirestore(() => getFirestore()),
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFireAuthModule,
    AngularFireFunctionsModule,
    BrowserAnimationsModule,
    MatSlideToggleModule,
    DatePipe,
    MatIconModule,

    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatProgressBarModule,
    MatStepperModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatIconModule,
    MatCardModule,
    MatDialogModule,
    MatSnackBarModule,
    MatExpansionModule,
    MatButtonModule,
    MatTabsModule,
    MatMenuModule,
    MatDialogModule,
    MatButtonModule,
    MatRadioModule,
    MatCheckboxModule,
    MatTooltipModule, MatInputModule, MatSelectModule, MatRadioModule, MatCheckboxModule,
    MatDatepickerModule, MatNativeDateModule,
    MatTableModule, MatIconModule, MatButtonModule,
    MatCardModule, MatPaginatorModule, MatSortModule, MatChipsModule, CommonModule,
    BrowserModule,
    HttpClientModule,
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),

    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
  ],
  providers: [
    {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {floatLabel: 'always'}},
    { provide: LocationStrategy, useClass: PublicMarketingLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true },
    { provide: REGION, useValue: 'us-central1' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
